import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetItemTreeListRowData  {
    _originalTypeClassName = "zERP.BO.BudgetItemTreeListRowData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetItemTreeListRowData.translate = translateService;
}
this.Name = null;
this.InitialApprovedAmount = null;
this.AdjustmentsAmount = null;
this.TotalBudgetAmount = null;
this.ReservedAmount = null;
this.RemainingBudgetAmount = null;
this.InvoicedAmount = null;
this.RemainingReservedAmount = null;
this.PaymentOrderedAmount = null;
this.RemainingInvoicedAmount = null;
this.PaidAmount = null;
this.RemainingPaymentOrderdAmount = null;
this.ExpenseReservedAmount = null;
this.BalanceToReserve = null;
this.ExpenseInvoicedAmount = null;
this.PendingReservations = null;
this.ExpensePaymentOrderAmount = null;
this.InvoicedToPaymentOrderRemaining = null;
this.ExpensePaidAmount = null;
this.PaymentOrderToBePaidRemaining = null;
this.IncomeReceiptApprovedAmount = null;
this.IncomeApprovedAmount = null;
this.ReceivedAmount = null;
this.IncomeSettledAmount = null;
this.InitialAmount = null;
this.TemporaryAmount = null;
this.AmountLastYear = null;
this.Amount2YearBefore = null;
this.Progress = null;
this.BudgetItemTreeListRowDataKey = null;
this._key = this.BudgetItemTreeListRowDataKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
InitialApprovedAmount:any;
AdjustmentsAmount:any;
TotalBudgetAmount:any;
ReservedAmount:any;
RemainingBudgetAmount:any;
InvoicedAmount:any;
RemainingReservedAmount:any;
PaymentOrderedAmount:any;
RemainingInvoicedAmount:any;
PaidAmount:any;
RemainingPaymentOrderdAmount:any;
ExpenseReservedAmount:any;
BalanceToReserve:any;
ExpenseInvoicedAmount:any;
PendingReservations:any;
ExpensePaymentOrderAmount:any;
InvoicedToPaymentOrderRemaining:any;
ExpensePaidAmount:any;
PaymentOrderToBePaidRemaining:any;
IncomeReceiptApprovedAmount:any;
IncomeApprovedAmount:any;
ReceivedAmount:any;
IncomeSettledAmount:any;
InitialAmount:any;
TemporaryAmount:any;
AmountLastYear:any;
Amount2YearBefore:any;
Progress:any;
private _BudgetItemTreeListRowDataKey:any;
get BudgetItemTreeListRowDataKey(): any {
    return this._BudgetItemTreeListRowDataKey;
  }
set BudgetItemTreeListRowDataKey(value: any) {
    this._BudgetItemTreeListRowDataKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BudgetItemTreeListRowDataKey == null || $this.BudgetItemTreeListRowDataKey == 0;
            }


}